import fetch from '@/helpers/fetch';
import params from '@/lib/params';

export const exUrl = '/api/config/user-config-list';

// 获取列表
export function getListData(content) {
  return fetch.get('/api/phone/wechat-list', content);
}

//新增
export function addInfo(content) {
  return fetch.post('/api/phone/wechat-create', null, {
    body: params(content)
  });
}

//编辑
export function editInfo(query,content) {
  return fetch.post('/api/phone/wechat-update', query, {
    body: params(content)
  });
}

//导入
export function uploadFile(content) {
  return fetch.postFast('/api/phone/wechat-import', null, {
    body:  content,
    headers: {
      // 'Content-Type': 'multipart/form-data',
    }
  });
}
//删除
export function deteleInfo(query) {
  return fetch.get('/api/phone/wechat-delete', query);
}

//注销
export function cancleInfo(content) {
  return fetch.post('/api/phone/batch-cancel', null,{
    body: params(content)
  });
}

// 获取详情
export function getDetail(content) {
  return fetch.get('/api/phone/wechat-update', content);
}

